import { userService } from "../services/user.services";
import { setAuthItem, clearAuthSession, broadcastLogout } from "./authSession";

const refreshIdToken = async (dispatch, logoutAction) => {
    const response = await userService.RefreshToken();
    if (response?.error === false && response?.data?.success_status === true) {
        // Keep localStorage + sessionStorage in sync so new/duplicated tabs don't inherit stale tokens.
        setAuthItem('IdToken', response.data.data);
    } else {
        if (response?.message?.response?.status === 400) {
            // Token is invalid/expired. Clear session and signal logout to App.
            // Do NOT redirect — let Redux + router handle navigation.
            const browserIdValue = localStorage.getItem('arcm_trust_browser_token');

            // Broadcast logout to other tabs BEFORE clearing auth
            // This ensures other tabs receive the event before we clear localStorage
            broadcastLogout('expired');

            clearAuthSession();
            localStorage.setItem('custom-status', 'inactive');
            localStorage.setItem('arcm_trust_browser_token', browserIdValue);

            // Close WebSocket so backend removes stale connection
            // Prevents duplicate session modal on re-login
            if (window.websocket && (window.websocket.readyState === 0 || window.websocket.readyState === 1)) {
                window.websocket.close();
            }

            // If dispatch is provided (from App.jsx), dispatch logout action to trigger Redux state update
            // This prevents a remount-refresh-fail loop: dispatch → loggedIn=false → router redirects to /
            if (dispatch && logoutAction) {
                dispatch(logoutAction());
            }
        }
    }
};

export default refreshIdToken;